import type { ArrowStyleType } from '@octopus-do/octopus-project-core'
import { ArrowSmooth, ArrowStraight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

// Key the menu reports to Toolbar.Root; the picked ArrowStyleType follows it.
export const ARROW_TYPE_MENU_ID = 'arrow_type'

export interface ArrowTypeOption {
  icon: React.FC<{ className?: string }>
  id: ArrowStyleType
  tooltip: string
}

export const ARROW_TYPE_OPTIONS: ArrowTypeOption[] = [
  { icon: ArrowSmooth, id: 'smooth', tooltip: 'Smooth' },
  { icon: ArrowStraight, id: 'straight', tooltip: 'Straight' },
]
